/**
 * Traductions françaises
 */

const fr = {
    // Calendrier
    calendar: {
        today: 'Auj.',
        month: 'M.',
        week: 'S.',
        day: 'J.',
        expandEarlyHours: 'Déplier 0-8h',
        collapseEarlyHours: 'Replier 0-8h',
        normalMode: 'NORMAL',
        addMode: 'AJOUT',
        offdayMode: 'CONGÉ',
        adminMode: 'Admin',
        limitSettings: 'Limites',
        helpTitle: 'Description du mode',
        helpNormal: 'NORMAL: Mode de base pour vérifier et gérer les réservations.',
        helpAdd: 'AJOUT: Mode pour créer de nouvelles réservations.',
        helpOff: 'CONGÉ: Mode pour définir les jours de congé.',
        blockedDay: "Jour bloqué pour l'ajout d'événements.",
        studioUnavailable: 'Studio indisponible ce jour.',
        overlappingLimit: 'Il y a déjà {limit} événements. Maximum {limit} autorisés.',
        concurrentLimitExceeded: "Limite d'événements simultanés dépassée: Limite par défaut ({limit}) - Paramètre global par défaut",
        modal: {
            restrictedAddTitle: 'Ajouter une période bloquée',
            restrictedEditTitle: 'Modifier la période bloquée',
            eventAddTitle: 'Ajouter un événement',
            eventEditTitle: "Modifier l'événement",
            reason: 'Motif',
            title: 'Titre',
            startDate: 'Date de début',
            endDate: 'Date de fin',
            startTime: 'Heure de début',
            endTime: 'Heure de fin',
            allDay: 'Toute la journée',
            fullDayRestriction: 'Bloqué toute la journée',
            timedRestriction: 'Créneau bloqué',
            saving: 'Enregistrement...',
            saveChanges: 'Enregistrer les modifications',
            addRestriction: 'Ajouter la période bloquée',
            addEvent: "Ajouter l'événement",
            reasonRequired: 'Saisissez un motif.',
            titleRequired: 'Saisissez un titre.',
            startRequired: 'Sélectionnez une heure de début.',
            endRequired: 'Sélectionnez une heure de fin.',
            endAfterStart: 'La fin doit être postérieure au début.',
        },
    },

    // Réservations
    reservation: {
        pageTitle: 'Réservations',
        status: 'Statut',
        type: 'Quoi',
        client: 'Client',
        date: 'Date',
        updated: 'Modifié',
        created: 'Créé',
        memo: 'Mémo',
        reservationDate: 'Date de réservation',
        instagram: 'Instagram',
        customerName: 'Nom du client',
        deposit: 'Acompte',
        finalPrice: 'Prix final',
        reservationType: 'Type de réservation',
        email: 'E-mail',
        phone: 'Téléphone',
        minPrice: 'Prix min',
        maxPrice: 'Prix max',
        budget: 'Budget',
        description: 'Description',
        preferredPart: 'Partie préférée',
        preferredDates: 'Dates préférées',
        referenceImages: 'Images de référence',
        flashImage: 'Image',
        category: 'Catégorie',
        artist: 'Artiste',

        // Libellés de statut
        statusLabels: {
            requested: 'Demandé',
            in_progress: 'En cours',
            pending: 'En attente',
            confirmed: 'Confirmé',
            deposit_paid: 'Acompte payé',
            deposit_confirmed: 'Acompte confirmé',
            completed: 'Terminé',
            cancelled: 'Annulé',
        },
    },

    // Commun
    common: {
        loading: 'Chargement...',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        close: 'Fermer',
        confirm: 'Confirmer',
        edit: 'Modifier',
        add: 'Ajouter',
        search: 'Rechercher',
        filter: 'Filtrer',
        yes: 'Oui',
        no: 'Non',
        noData: 'Aucune donnée',
        enterMemo: 'Entrez le mémo...',
    },

    // Messages d'erreur
    error: {
        eventUpdateError: "Erreur lors de la modification de l'événement.",
        startEndTimeRequired: 'Les heures de début et de fin sont requises.',
        endTimeAfterStart: "L'heure de fin doit être après l'heure de début.",
        userInfoError: 'Impossible de charger les infos utilisateur. Veuillez rafraîchir la page.',
        dayOffDeleteError: 'Échec de la suppression du congé.',
        dayOffAddError: "Échec de l'ajout du congé.",
        blockDeleteError: 'Échec de la suppression de la période bloquée.',
        blockAddError: "Échec de l'ajout de la période bloquée.",
        unknownError: "Une erreur inconnue s'est produite.",
        depositConfirmFailed: "Échec de confirmation d'acompte : ",
        depositCancelFailed: "Échec d'annulation d'acompte : ",
        depositProcessError: "Une erreur s'est produite lors du traitement de l'acompte : ",
        deleteConfirm: 'Êtes-vous sûr de vouloir supprimer?',
        deleteSuccess: 'Supprimé avec succès',
    },

    // Messages de succès
    success: {
        eventUpdatedSuccess: 'Événement modifié avec succès.',
        blockRemoved: 'Période bloquée supprimée.',
        blockAdded: 'Période bloquée ajoutée.',
    },

    // Messages/DM
    message: {
        noPermission: 'Pas de permission - pas votre événement.',
        updatingEvent: 'Modification...',
        noConnectedEvent: 'Aucun événement connecté',
    },

    // Widget météo
    weather: {
        days: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    },

    // Résumé des réservations
    summary: {
        thisMonth: 'Ce mois',
        thisWeek: 'Cette semaine',
        today: "Aujourd'hui",
        count: '',
        next: 'Prochain',
        pendingDeposit: 'Acompte en attente',
        noName: 'Sans nom',
    },

    // Annonce de la page principale
    announcement: {
        title: 'Annonce',
        write: 'Rédiger une annonce',
        edit: 'Modifier',
        clear: 'Retirer',
        clearing: 'Retrait...',
        contentLabel: "Contenu de l'annonce",
        empty: "Aucune annonce n'est publiée.",
        save: 'Enregistrer',
        saving: 'Enregistrement...',
        cancel: 'Annuler',
        clearConfirm: "Retirer l'annonce actuelle ?",
        contentRequired: "Saisissez le contenu de l'annonce.",
        contentTooLong: "L'annonce ne doit pas dépasser {max} caractères.",
        loadError: "Impossible de charger l'annonce.",
        saveError: "Impossible d'enregistrer l'annonce.",
        clearError: "Impossible de retirer l'annonce.",
    },

    // Flashbook
    flashbook: {
        title: 'FLASH BOOK',
        newPlanche: '+ NOUVEAU',
        empty: 'Pas encore de planches',
        emptyHint: 'Créez votre première planche',
        createError: 'Échec création',
        available: 'Dispo',
        sold: 'Vendu',
        replaceImage: 'Rempl.',
        download: 'Tél.',
        downloadAll: 'Télécharger tous les flashs',
        downloadAllError: 'Échec du téléchargement des flashs.',
        crop: 'Rogner',
        flashName: 'Nom',
        size: 'Taille',
        showInfo: 'Info',
        visible: 'ON',
        hidden: 'OFF',
        downloadOriginal: 'Original',
        downloadCanvas: 'Canvas',
        deleteFailed: 'Échec suppr.',
        deleteConfirm: 'Suppr. {number}?',
        nameSaved: 'Nom enreg.',
        sizeSaved: 'Taille enreg.',
        soldStyle: 'SOLD',
        titleStyle: 'TITRE',
        bgStyle: 'FOND',
    },

    // Stock Management
    stock: {
        title: 'STOCK',
        add: 'AJOUTER',
        save: 'SAUVER',
        cancel: 'ANNULER',
        delete: 'SUPPR.',
        name: 'Nom',
        quantity: 'Qté',
        category: 'Catégorie',
        image: 'Image URL',
        supplier: 'Fournisseur',
        priceHT: 'Prix HT',
        tvaRate: 'TVA %',
        minStock: 'Stock min',
        noData: 'Aucun article',
        noAccess: 'Pas d\'accès',
        lowStock: 'BAS',
        all: 'Tous',
        uncategorized: 'Non catégorisé',
        searchPlaceholder: 'Rechercher...',
        confirmDelete: 'Supprimer cet article?',
        addItem: 'AJOUTER',
        editItem: 'MODIFIER',
        loadError: 'Échec chargement',
        saveError: 'Échec sauvegarde',
        deleteError: 'Échec suppression',
        categories: 'Catégories',
        newCategory: 'Nouvelle catégorie...',
    },
};

export default fr;
